import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import {MatTableDataSource, MatPaginator } from '@angular/material';
import { ExaminationService } from 'src/app/shared/services/examination.service';
import { AppSettings } from '../../../app.constant';
import { DataSource } from '@angular/cdk/table';

@Component({
  selector: 'app-tempexam-table',
  templateUrl: './tempexam-table.component.html',
  styleUrls: ['./tempexam-table.component.css']
})
export class TempexamTableComponent implements OnInit {

  displayedColumns: string[] =  ['FK_StudentID','FK_BatchID','FK_SubjectID','CA','Exam','ExamSection'];
  post:any;
  public resultdata:any;
  dataSource;
  students:any;
  errorMessage: String;
  progressBar:boolean = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _examinationservice:ExaminationService, 
    private changeDetectorRefs: ChangeDetectorRef) { }

  ngOnInit() {
    this._examinationservice.refreshNeeded$
    .subscribe(()=>{
      this.getAllTempExam();
    })
    this.getAllTempExam();
  }

  ExamToProduction() {
    this._examinationservice.TrasferTempExams(AppSettings.API_ENDPOINT+AppSettings.ExamToProduction)
    .subscribe(result =>{
       this.resultdata=result;
       this.progressBar = false;
       this.changeDetectorRefs.detectChanges();
       if(!result){
        return;
        }
    })
  }
  
  getAllTempExam() {
    this._examinationservice.getAllTempExam(AppSettings.API_ENDPOINT+AppSettings.GetAllTempExams)
    .subscribe(result =>{
      this.resultdata=result;
      this.progressBar = false;
      this.changeDetectorRefs.detectChanges();
      if(!result){
        return;
    }
    this.dataSource = new MatTableDataSource(this.resultdata);
    this.dataSource.paginator = this.paginator;
  });

  }
}

